import React, { useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import TriangleFrame from "assets/images/CT/triangle-frame.png";
import Alert from "components/shared/common/alert";
import Over from "./Over";
import CTStart from "./CTStart";
import CoverUp from "./CoverUp";
import Doubles from "./Doubles";
import Question from "./Question";
import Discovery from "./Discovery";
import TurnResult from "./turnResult";
import KeyInformation from "./KeysInformation";

const position_coordinates = [
  { top: 5, left: 48 },
  { top: 17, left: 58 },
  { top: 24, left: 62 },
  { top: 31, left: 65 },
  { top: 38, left: 69 },
  { top: 45, left: 72 },
  { top: 53, left: 75 },
  { top: 59, left: 78 },
  { top: 66, left: 82 },
  { top: 73, left: 85 },
  { top: 86, left: 91 },
  { top: 94, left: 74 },
  { top: 94, left: 68 },
  { top: 94, left: 61 },
  { top: 94, left: 54 },
  { top: 94, left: 48 },
  { top: 94, left: 41 },
  { top: 94, left: 34.5 },
  { top: 94, left: 28 },
  { top: 94, left: 21 },
  { top: 94, left: 10 },
  { top: 74, left: 10 },
  { top: 66, left: 14 },
  { top: 60, left: 17 },
  { top: 52, left: 21 },
  { top: 46, left: 23 },
  { top: 38, left: 27 },
  { top: 31, left: 30 },
  { top: 24, left: 34 },
  { top: 17, left: 37 }
];

const CTRightContent = (props) => {
  const room_obj = _.get(props, "gameReducer.roomObj");
  const soundParam = _.get(props, "paramsReducer.gameObj.sounds");
  const game_state = _.get(room_obj, "game_state");
  const status = _.get(game_state, "status");
  const dice_ob = _.get(game_state, "dice");
  const dice = _.get(dice_ob, "dice");
  const dice_special = _.get(dice_ob, "dice_special");
  const space_result = _.get(dice_ob, "space_result");
  const player_status = _.get(game_state, "player_status");
  const active_player = _.get(game_state, "active_player");
  const users = _.get(room_obj, "users");
  const active_player_details = _.find(users, { player_id: active_player });
  const question = _.get(game_state, "question");
  const chosen_answer_1 = _.get(game_state, "chosen_answer");
  const chosen_answer_2 = _.get(game_state, "chosen_answer_2");
  const final_answer = chosen_answer_2 || chosen_answer_1;
  const correct_answer = _.get(question, "correct_answer");
  const discard_pile = _.get(game_state, "discard_pile");
  const coverup = _.get(game_state, "cover_up");
  const card_stolen_from = _.get(game_state, "card_stolen_from", null);
  const branch_redirect_domain = _.get(
    props,
    "gameReducer.gamesData.branch_redirect_domain"
  );
  const link = _.get(props, "gameReducer.branchlink.url");
  const { colours } = props;
  const posiotion_mem = {};

  const joinRoom = () => {
    const branchLinkSplit = link.split("/")[3];
    let copyToClip = `${branch_redirect_domain}${branchLinkSplit}`;
    var textArea = document.createElement("textarea");
    document.body.append(textArea);
    document.body.lastElementChild.value = copyToClip;
    document.body.lastElementChild.select();
    document.execCommand("copy");
    textArea.remove();
    Alert(200, "Link copied successfully");
  };
  const any_other_player_has_cards = () => {
    if (player_status && player_status.length > 0) {
      for (let player of player_status) {
        for (let card_type of Object.keys(player.cards)) {
          if (player.cards[card_type] > 0) {
            return true;
          }
        }
      }
      return false;
    }
  };

  const get_position_coordinates = (player, posiotion_mem) => {
    if (player.position in posiotion_mem) {
      posiotion_mem[player.position] = posiotion_mem[player.position] + 1;
      if (player.position > 20) {
        return {
          top: `${
            position_coordinates[player.position - 1].top +
            posiotion_mem[player.position]
          }%`,
          left: `${
            position_coordinates[player.position - 1].left -
            posiotion_mem[player.position]
          }%`
        };
      } else {
        return {
          top: `${
            position_coordinates[player.position - 1].top +
            posiotion_mem[player.position]
          }%`,
          left: `${
            position_coordinates[player.position - 1].left +
            posiotion_mem[player.position]
          }%`
        };
      }
    } else {
      posiotion_mem[player.position] = 0;
      return {
        top: `${position_coordinates[player.position - 1].top}%`,
        left: `${position_coordinates[player.position - 1].left}%`
      };
    }
  };

  const playAudio = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none";
    audio.autoplay = true;
    audio.onended = function () {
      audio.remove();
    };
    document.body.appendChild(audio);
  };

  useEffect(() => {
    switch (status) {
      case "StartTurn":
      case "Joining":
      case "Over":
        return playAudio(soundParam?.victory_sound);
      case "Question":
        return playAudio(soundParam?.question_sound);
      case "DiceRollResult":
        switch (space_result) {
          case "Discover":
            return playAudio(soundParam?.discovery_sound);
          case "Cover Up":
            return playAudio(soundParam?.coverup_sound);
          case "Double":
            return playAudio(soundParam?.doubles_sound);
          // default:
          //   return playAudio(soundParam.roll_dice_sound);
        }
      case "TurnResult":
        if (correct_answer === final_answer) {
          return playAudio(soundParam?.correct_sound);
        } else {
          return playAudio(soundParam?.wrong_sound);
        }
      default:
        playAudio(soundParam?.default_sound || "");
    }
  }, [status, space_result]);

  useEffect(() => {
    if (dice || dice_special) {
      return playAudio(soundParam?.roll_dice_sound);
    }
  }, [dice && dice[0], dice && dice[1], dice_special]);

  return (
    <>
      <div className="frame-content-wrapper">
        <div className="frame-wrapper">
          <div className="TriangleFrameContainer">
            <img
              src={TriangleFrame}
              alt="TriangleFrame"
              className="img-fluid triangle-frame"
            />
            {player_status?.map((player) => (
              <div
                className="small-user"
                style={get_position_coordinates(player, posiotion_mem)}
              >
                {users?.map((user, index) => {
                  if (user.player_id === player.id) {
                    return (
                      <img
                        src={user.profile_image}
                        alt="profileimage"
                        className={colours[user.player_id - 1]}
                      />
                    );
                  }
                })}
              </div>
            ))}

            <div className="triangle-frame-content">
              {status === "StartTurn" && (
                <CTStart player={active_player_details} colours={colours} />
              )}
              {status === "Question" && (
                <Question
                  dice={dice}
                  active_player_details={active_player_details}
                  space_result={space_result}
                />
              )}
              {status === "DiceRollResult" && space_result === "Discover" && (
                <Discovery
                  active_player_details={active_player_details}
                  dice_ob={dice_ob}
                  discard_pile={discard_pile}
                  any_other_player_has_cards={any_other_player_has_cards}
                  card_stolen_from={card_stolen_from}
                  users={users}
                />
              )}

              {status === "TurnRes" && (
                <TurnResult
                  question={question}
                  chosen_answer={final_answer}
                  active_player_details={active_player_details}
                />
              )}
              {status === "DiceRollResult" && space_result === "Cover Up" && (
                <CoverUp
                  coverUp={coverup}
                  active_player_details={active_player_details}
                />
              )}
              {status === "DiceRollResult" && space_result === "Double" && (
                <Doubles
                  dice_ob={dice_ob}
                  active_player_details={active_player_details}
                  any_other_player_has_cards={any_other_player_has_cards}
                  discard_pile={discard_pile}
                  users={users}
                  card_stolen_from={card_stolen_from}
                />
              )}
              {status === "TurnResult" && (
                <TurnResult
                  question={question}
                  chosen_answer={final_answer}
                  active_player_details={active_player_details}
                />
              )}
              {status === "Over" && (
                <Over
                  users={users}
                  player_status={player_status}
                  colours={colours}
                />
              )}
            </div>
          </div>
          <KeyInformation joinRoom={joinRoom} room_obj={room_obj} />
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CTRightContent);
